import { render, staticRenderFns } from "./ninegrid.vue?vue&type=template&id=3daa6113&"
import script from "./ninegrid.vue?vue&type=script&lang=js&"
export * from "./ninegrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports